
Vue.component("question_detail", {
  props: {
      topic_id: {
          type: String,
          required: true,
          default: ""
      },
      user_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      current_info: {
          type: Object,
          required: true,
          default: () => ({})
      },
      course_id: {
          type: String,
          required: true,
          default: ""
      },
      teachers_code: {
        type: Array,
        required: true,
        default: () => []
      },
  },
  data() {
      return {
          commentValue: "",
          commentList: [],
          pagination: {
              page: 1,
              size: 10
          },
          // topicData: {},
          total: 0,
          detailData: {},
          isAnonymous: false
      }
  },
  computed: {
    canDelete() {
      return this.user_info.user_code == this.detailData.user_id || this.user_info.roles?.includes('r_sys_manager') || this.user_info.roles?.includes('r_course_manager') || this.teachers_code.includes(this.user_info.user_code)
    },
    canOpen() {
      return (this.user_info.roles?.includes('r_sys_manager') || this.user_info.roles?.includes('r_course_manager') || this.teachers_code.includes(this.user_info.user_code)) && window.location.pathname.includes('mooc')
    }
  },
  methods: {
      backHandle() {
          this.$emit("back")
      },
      initList() {
          this.pagination.page = 1
          this.getCommentList();
          this.getQuestionDetail()
      },
      getQuestionDetail() {
          const params = {
              link_id: this.course_id,
              extend_link_id: this.current_info.guid_,
              extend_type: window.location.pathname.includes("mooc") ? "04" : window.location.pathname.includes("spoc") ? "02" : window.location.pathname.includes("training") ? '06': '',
              topic_id: this.topic_id,
          }
          API.reqQuestion(params).then(res => {
              if (res.error_msg === "Success") {
                  this.detailData = res.extend_message.results?.[0];
              }
          })
      },
      getUserIds(data, arr = []) {
          return data.map(item => {
              if (item.reply_list?.length > 0) {
                  this.getUserIds(item.reply_list, arr)
              }
              if (!arr.includes(item.user_id)) {
                  arr.push(item.user_id)
              }
              return arr
          })
      },
      addAvatar(avatarList, list) {
          return list.map(item => {
              let reply_list = []
              if (item.reply_list?.length > 0) {
                  reply_list = this.addAvatar(avatarList, item.reply_list)
              }
              const avatar = avatarList.filter(avatar => (avatar.user_id === item.user_id))?.[0]
              return {
                  ...item,
                  avatar_url: avatar?.avatar_url || "",
                  reply_list
              }
          })
      },
      getCommentList() {
          const params = {
              // depth: 1,
              link_id: this.course_id,
              height: 1,
              topic_id: this.topic_id,
              user_id_of_unread: this.user_info.user_code,
              ...this.pagination,
              sub_size: 9999,
          }
          API.reqComment(params).then(res => {
              if (res.error_msg === "Success") {
                  const users = this.getUserIds(res.extend_message.results)?.flat() ?? []
                  const list = res.extend_message.results
                  if (list.filter(item => item.unread_id).length > 0) {
                      API.updateRead({ids: list.filter(item => item.unread_id).map(item => item.unread_id).join(",")})
                  }
                  if(!users.length) return
                  API.reqAvatarList({ user_id_list: Array.from(new Set(users)), link_id: this.course_id }).then(res2 => {
                      if (res2.error_msg === "Success") {
                          this.commentList = this.addAvatar(res2.extend_message.user_list, list);
                      } else {
                          this.commentList = list;
                      }
                  })
                  this.total = res.extend_message.count
              }
          })
      },
      submitComment() {
        if (this.commentValue == "" || this.commentValue == null) {
          this.$message.warning("发表的内容不能为空！")
          return
        }
          const params = {
              link_id: this.course_id,
              topic_id: this.topic_id,
              content: this.commentValue,
              user_id: this.user_info.user_code,
              user_name: this.user_info.nick_name,
              user_roles: this.user_info.roles,
              anonymity: this.isAnonymous
          }
          API.reqSensitiveWord(this.commentValue, '内容', () => API.addComment(params)).then(res => {
              if (res.error_msg === 'Success') {
                  this.$message.success({message: this.$t("发表成功"), customClass: 'qustion_success'});
                  this.commentValue = "";
                  this.isAnonymous = false;
                  // this.commentList.unshift(res.extend_message);
                  this.initList()
              } else {
                  this.$message.error(res.extend_message)
              }
          })
      },
      handleCurrentChange(page) {
          this.pagination.page = page;
          this.getCommentList();
      },
      deleteComment(isReply) {
          if (!isReply) {
              if (this.commentList.length === 1) {
                if (this.pagination.page > 1) {
                  this.pagination.page--;
                }

              }
              this.getCommentList();
          }
      },
      deleteHandle() {
        API.deleteQuestion({topic_id_list: [this.topic_id], link_id: this.course_id}).then(res => {
            if (res.error_msg === "Success") {
                this.$message.success("删除成功")
                this.backHandle()
            } else {
                this.$message.error("删除失败")
            }
        })
      },
      handlePublic(isPublic, isEdit) {
        if (isPublic) {
          this.$refs["public-qa-modal"].visible = true;
          if (isEdit) {
            this.$refs["public-qa-modal"].publicValue = this.detailData.permissions;
          }
        } else {
          API.updateQaStatus({ link_id: this.course_id, topic_id: this.topic_id, permissions: "0" }).then(res => {
            if (res.error_msg === "Success") {
              this.changePublicStatus(this.topic_id, "0");
              this.$message.success("取消公开成功！");
            } else {
              this.$message.error("取消公开失败!");
            }
          });
        }
      },
      changePublicStatus(topicId, permissions) {
        this.detailData.permissions = permissions;
      }
  },
  watch: {
      topic_id: {
          handler(newVal) {
              if (newVal) {
                  this.initList();
              }
          },
          immediate: true
      }
  },
  template: `
  <div class="question_detail">
    <span class="back-container" @click="backHandle"><i class="el-icon-arrow-left"></i>{{$t('返回')}}</span>
    <div class="header-container">{{detailData.title}}</div>
    <div class="footer-container">
      <span class="stu-name2">{{detailData.user_name}}</span>
      <div class="col-line"></div>
      <span>{{dateFormate(Number(detailData.created + '000'), "y.m.d h:i")}}{{$t('提问')}}</span>
    </div>
    <div class="content">{{detailData.content}}</div>
    <div class="tool_bar">
      <template v-if="canOpen">
        <template v-if="detailData.permissions && detailData.permissions != '0'">
          <el-button
            type="text"
            size="mini" icon="el-icon-unlock"
            @click="handlePublic(true, true)"
          >{{$t('修改公开类型')}}</el-button>
          <el-button
            type="text"
            size="mini" icon="el-icon-lock"
            @click="handlePublic(false)"
          >{{$t('取消公开')}}</el-button>
        </template>
        <el-button
          v-else
          type="text"
          size="mini" icon="el-icon-unlock"
          @click="handlePublic(true)"
        >{{$t('设为公开')}}</el-button>
      </template>
      <el-popconfirm
        :title="$t('确定删除当前问答吗？')"
        @confirm="deleteHandle"
      >
        <el-button
          type="text"
          v-show="canDelete"
          size="mini"
          slot="reference"
        ><iconfont type="icondelete1"></iconfont>{{$t('删除')}}</el-button>
      </el-popconfirm>
    </div>
    <div class="line-container">
      <div class="line-left"></div>
      <div class="line-right"></div>
    </div>
    <div class="reply-container">
      <div class="reply-count">{{total}}{{$t('条回复')}}</div>
        <el-input v-model="commentValue" />
        <div class="reply-btn">
          <el-tooltip :content="$t('匿名仅对课程内同学生效，老师仍可见真实姓名')">
            <el-checkbox v-if="window.location.pathname.includes('spoc') || window.location.pathname.includes('training')" v-model="isAnonymous">{{$t('匿名发表')}}</el-checkbox>
          </el-tooltip>
          <el-tooltip :disabled="detailData.can_reply" :content="!detailData.can_reply && detailData.permissions == '1' ? $t('仅教师团队可继续回复') : !detailData.can_reply && detailData.permissions == '2' ? $t('仅提问人和教师团队可继续回复') : null">
              <div><el-button :disabled="!detailData.can_reply" type="primary" size="small" @click="submitComment">{{$t('发表')}}</el-button></div>
          </el-tooltip>
          
        </div>
    </div>
    <div v-for="item in commentList" :key="item.comment_id" class="comment-item-container">
      <comment_item  :content="item" :user_info="user_info" :teachers_code="teachers_code" :course_id="course_id" @delete="deleteComment" @refresh="getCommentList"/>
      <div class="comment-children-container" v-if="item.reply_list.length > 0">
        <comment_item v-for="el in item.reply_list" :teachers_code="teachers_code" :course_id="course_id" isReply="true" :key="el.comment_id"  :content="el" :user_info="user_info" @delete="deleteComment" @refresh="getCommentList"/>
      </div>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.page"
      :page-size="pagination.size"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
    <public_qa_modal ref="public-qa-modal" :course_id="course_id" :topic_id="topic_id" @onPublic="changePublicStatus" />
  </div>
`
});